$/*
描述：传稿提示
日期：2017-65-17
作者：Bai.Zhiming
 */
'use strict';
angular.module("noticeOfPassDraftModule", []).controller("noticeOfPassDraftCtrl", ["$scope", "$state", "$rootScope", "$q", "$timeout", "$interval", "trsHttpService", function($scope, $state, $rootScope, $q, $timeout, $interval, trsHttpService) {
    initStatus();
    initData();
    /**
     * [openDraft description]初始化状态
     * @param  {[object]} item  [description] 稿件对象
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    $scope.openDraft = function(item) {
        var draftHref = $state.href('iwopreview', {
            'chnldocid': item.CHNLDOCID,
            'metadataid': item.DOCID,
            'modalname': 'iwo.received',
            'type': item.DOCTYPE
        });
        $rootScope.$broadcast("readPassDraft", {
            metadataid: item.DOCID,
            chnldocid: item.CHNLDOCID
        });
        window.open(draftHref);
    };
    /**
     * [closeUnreadTip description]关闭提示
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    $scope.closeUnreadTip = function() {
        delete $scope.data.passDraftList;
        $scope.status.show = false;
    };
    /**
     * [initStatus description]初始化状态
     * @param  {[]}  [description]
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    function initStatus() {
        $scope.status = {
            show: false,
        };
        $scope.data = {};
    }
    /**
     * [initData description]初始化数据
     * @param  {[]}  [description]
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    var myInterval;

    function initData() {
        startInterval();
        $scope.$on("loginSuccess", function() {
            startInterval();
        });
    }

    function startInterval() {
        $interval.cancel(myInterval);
        getTimeRange().then(function() {
            myInterval = $interval(function() {
                getPassDraftList();
            }, $scope.status.timeRange);
        });
    }
    /**
     * [getPassDraftList description]获取传稿列表
     * @param  {[]}  [description]
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    function getPassDraftList() {
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_releasesource",
            methodName: "queryPassDocs"
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            if (data.length > 0) {
                $scope.data.passDraftList = data;
                $scope.status.show = true;
                $rootScope.$broadcast('newPassDraft', true);
                countDown().then(function() {
                    delete $scope.data.passDraftList;
                    $scope.status.show = false;
                });
            }
            deffer.resolve();
        });
        return deffer.promise;
    }
    /**
     * [countDown description]关闭倒计时
     * @param  {[]}  [description]
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    var countDownInterval;

    function countDown() {
        var deffer = $q.defer();
        $scope.status.remainingTime = $scope.status.timeRange / 1000;
        $interval.cancel(countDownInterval);
        countDownInterval = $interval(function() {
            if ($scope.status.remainingTime > 0) {
                $scope.status.remainingTime -= 1;
            } else {
                $interval.cancel(countDownInterval);
                deffer.resolve();
            }
        }, 1000);
        return deffer.promise;
    }
    /**
     * [getTimeRange description]获取查询时间范围
     * @param  {[]}  [description]
     * @param  {[]}  [description]
     * @return {[]}  [description]
     */
    function getTimeRange() {
        var deffer = $q.defer();
        var params = {
            serviceid: "mlf_releasesource",
            methodname: "getIntervalTime"
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
            $scope.status.timeRange = Number(data.replace(/"/g, "")) * 1000;
            deffer.resolve();
        });
        return deffer.promise;
    }
}]).run(["$rootScope", "$templateRequest", "$controller", "$timeout", "$compile", function($rootScope, $templateRequest, $controller, $timeout, $compile) {
    return;  //稿件列表提示功能暂时屏蔽
    $templateRequest("./editingCenter/noticeOfPassDraft/noticeOfPassDraft_tpl.html").then(function(template) {
        var ctrlLocals = {};
        ctrlLocals.$scope = $rootScope.$new();
        var ctrlInstance = $controller("noticeOfPassDraftCtrl", ctrlLocals);
        var dom = document.createElement("div");
        dom.innerHTML = template;
        dom = $compile(dom)(ctrlLocals.$scope);
        $("body").append(dom);
    });
}]);
